import React from "react";

function TopStats() {
  return (
    <div className="col-xs-12 col-sm-12 col-md-4">
      <div className="row">

        {/* En İyi 5 Oyuncu */}
        <div className="col-xs-12 col-sm-6 col-md-12">
          <div className="block">
            <div className="header">
              <h3>EN İYİ 5 OYUNCU</h3>
            </div>
            <ul className="top-user-list">
              {/* Buraya map ile oyuncular döngüsü eklenebilir */}
              {/* <li><a href="#!">Oyuncu Adı</a></li> */}
            </ul>
          </div>
        </div>

        {/* En İyi 5 Clan */}
        <div className="col-xs-12 col-sm-6 col-md-12">
          <div className="block">
            <div className="header">
              <h3>EN İYİ 5 CLAN</h3>
            </div>
            <ul className="top-clan-list">
              {/* Buraya map ile clanlar döngüsü eklenebilir */}
            </ul>
          </div>
        </div>

        {/* Krallar */}
        <div className="col-xs-12 col-sm-6 col-md-12">
          <div className="block">
            <div className="header">
              <h3>KRALLAR</h3>
            </div>
            <ul className="top-user-list">
              <li>
                <p>
                  <b className="nation n1"></b>
                  <b className="class c11"></b>
                  <b
                    className="clanicon"
                    style={{
                      backgroundImage: "url(assets/upload/clanicon/clan.png)",
                    }}
                  ></b>
                </p>
                <a href="#!">KRAL KARUS</a>
                <span className="status-button off">Offline</span>
              </li>
              <li>
                <p>
                  <b className="nation n2"></b>
                  <b className="class c23"></b>
                  <b
                    className="clanicon"
                    style={{
                      backgroundImage: "url(assets/upload/clanicon/clan.png)",
                    }}
                  ></b>
                </p>
                <a href="#!">KRAL EL MORAD</a>
                <span className="status-button off">Offline</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Barlar ve Sunucu Bilgisi */}
        <div className="col-xs-12 col-sm-6 col-md-12">
          <div className="counter-bar-left">
            <div className="counter-bar">
              <div className="e-logo"></div>
              <div className="bar">
                <div className="elmorad index" style={{ width: "70%" }}>
                  <span>70%</span>
                </div>
                <div className="karus" style={{ width: "30%" }}>
                  <span>30%</span>
                </div>
              </div>
              <div className="k-logo"></div>
            </div>
          </div>
          <div className="counter-bar-left">
            <ul className="server-status">
              <li>OYUNCU<span> Kişi</span></li>
              <li>SUNUCU<span className="on">Online</span></li>
              <li>SAAT<span>00:28</span></li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  );
}

export default TopStats;
